import './FilterBar.scss';

import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import {connect} from "react-redux";
import {toastr} from "react-redux-toastr";
import {isArray} from "validate.js";

import {Dropdown, DropdownMenu, DropdownToggle, Input, Modal as BootstrapModal, ModalBody} from 'reactstrap';
import {
  Archive,
  Briefcase,
  Calendar,
  Compass,
  DollarSign,
  FileText,
  List,
  Menu,
  MessageSquare,
  Monitor,
  Save,
  Trash,
  User,
  X
} from 'react-feather';

import withManagers from "../../HOC/withManagers.jsx";
import api from "../../../api.js";

import CardRow from "../Styled/Card/CardRow.jsx";
import CardCol from "../Styled/Card/CardCol.jsx";

import FilterCity from './components/FilterCity/FilterCity.jsx';
import FilterManager from './components/FilterManager/FilterManager.jsx';
import FilterOrder from "../FilterOrder/FilterOrder.jsx";
import FilterType from './components/FilterType/FilterType.jsx';
import FilterExperience from "./components/FilterExperience/FilterExperience.jsx";
import FreelanceFilterType from "./components/FilterType/FreelanceFilterType.jsx";
import FilterAvailability, {availabilityChoices} from "./components/FilterAvailability/FilterAvailability.jsx";
import FilterLanguages from "./components/FilterLanguages/FilterLanguages.jsx";
import FilterSecteur from "./components/FilterSecteur/FilterSecteur.jsx";
import FilterItSkills from "./components/FilterItSkills/FilterItSkills.jsx";
import FilterPrices from "./components/FilterPrices/FilterPrices.jsx";
import FilterBool from "./components/FilterBool/FilterBool.jsx";
import FilterDistance from "./components/FilterDistance/FilterDistance.jsx";
import UserSavedFilter from "./components/UserSavedFilter/UserSavedFilter.jsx";

import {
  AVAILABILITY_FILTER_KEY,
  CITY_FILTER_KEY,
  IT_SKILLS_FILTER_KEY,
  LANGUAGE_FILTER_KEY,
  MANAGER_FILTER_KEY,
  MY_APPLICATION_FILTER_KEY,
  NB_YEAR_OF_EXPERIENCE_FILTER_KEY,
  PRICE_MIN_FILTER_KEY,
  PRICE_MAX_FILTER_KEY,
  RELOCATION_FILTER_KEY,
  SECTEUR_FILTER_KEY,
  TYPE_FILTER_KEY, DISTANCE_FILTER_KEY,
} from "../../constants/filters.js";


class FilterBar extends Component {
  static propTypes = {
    conf: PropTypes.object.isRequired,
    count: PropTypes.number,
    className: PropTypes.string,
    isConnected: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isManager: PropTypes.bool,
    isOnlyMy: PropTypes.bool,
    isCity: PropTypes.object,
    priceRange: PropTypes.object,
    prices: PropTypes.object,
    searchQuery: PropTypes.object,
    target: PropTypes.string.isRequired,
    topologies: PropTypes.array,
    currentUser: PropTypes.object,
    filters: PropTypes.object,
  };

  static defaultProps = {
    count: 0,
    className: '',
    isConnected: false,
    isAdmin: false,
    isManager: false,
    isCity: {all: false, remote: false},
    topologies: [],
    currentUser: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      cityDropdownOpened: false,
      managerDropdownOpened: false,
      orderDropdownOpened: false,
      topologyDropdownOpened: false,
      myApplicationDropdownOpened: false,
      nbYearOfExperienceDropdownOpened: false,
      availabilityDropdownOpened: false,
      languageDropdownOpened: false,
      sectorDropdownOpened: false,
      itSkillsDropdownOpened: false,
      pricesDropdownOpened: false,
      userSavedDropdownOpened: false,
      mobileFilterOpen: false,
      isFilterModalOpen: false,
      savedFilterNameOpened: false,
      savedFilterName: '',
      languageLabel: undefined,
    };

    this.toggleCityDropdown = this.toggleCityDropdown.bind(this)
    this.toggleManagerDropdown = this.toggleManagerDropdown.bind(this)
    this.toggleOrderDropdown = this.toggleOrderDropdown.bind(this)
    this.toggleTopologyDropdown = this.toggleTopologyDropdown.bind(this)
    this.toggleMyApplicationDropdown = this.toggleMyApplicationDropdown.bind(this)
    this.toggleNbYearOfExperienceDropdown = this.toggleNbYearOfExperienceDropdown.bind(this)
    this.toggleAvailabilityDropdown = this.toggleAvailabilityDropdown.bind(this)
    this.toggleLanguageDropdown = this.toggleLanguageDropdown.bind(this)

    this.getFilterNbYearOfExperience = this.getFilterNbYearOfExperience.bind(this)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      props : currentProps,
      state : currentState
    } = this

    const currentLanguages = currentProps?.searchQuery.languages
    const prevLanguages = prevProps?.searchQuery.languages

    if (currentLanguages && prevLanguages !== currentLanguages) {
      const updateLanguageLabel = async () => {
        const languageLabel  = (await api.languages.name({languageId: this.extractIdFromLanguageArray(currentLanguages)})).data;
        if(languageLabel) {
          this.setState({
            languageLabel: languageLabel
          })
        }
      }
      updateLanguageLabel()
      return
    }

    if (
      (currentLanguages && !currentState.languageLabel)
    ) {
      const updateLanguageLabel = async () => {
        const languageLabel  = (await api.languages.name({languageId: this.extractIdFromLanguageArray(currentLanguages)})).data;
        if(languageLabel) {
          this.setState({
            languageLabel: languageLabel
          })
        }
      }
      updateLanguageLabel()
      return
    }
  }

  isFreelanceSearch = () => {
    const { target , conf} = this.props
    return target === conf.search.targets.freelances
  }

  roundUp = (nb, steps = 100) => {
    if (Math.floor(nb / steps) !== nb / steps) {
      return Math.ceil(nb / steps) * steps;
    }
    return nb;
  };

  onFiltersChange = (value) => {
    const keys = Object.keys(value);
    for (let i = 0; i < keys.length; i++) {
      for (let j = 0; j < this.props.filters.orders.length; j++) {
        if (keys[i] !== this.props.filters.orders[j].name) {
          value[this.props.filters.orders[j].name] = null;
        }
      }
    }
    this.props.onChange(value);
  };

  getFilter = (key) => {
    return this.props.searchData?.search?.[key]
  }
  deleteAllFilters = () => {
    const {onChange, searchQuery, topologies} = this.props
    const data = searchQuery
    delete data[CITY_FILTER_KEY]
    delete data['latitude']   // ℹ️ come with CITY_FILTER_KEY
    delete data['longitude']  // ℹ️ come with CITY_FILTER_KEY
    delete data[RELOCATION_FILTER_KEY]
    delete data[DISTANCE_FILTER_KEY]
    delete data[TYPE_FILTER_KEY]
    delete data[MANAGER_FILTER_KEY]
    delete data[MY_APPLICATION_FILTER_KEY]
    delete data[NB_YEAR_OF_EXPERIENCE_FILTER_KEY]
    delete data[AVAILABILITY_FILTER_KEY]
    delete data[LANGUAGE_FILTER_KEY]
    this.setState({languageLabel: undefined})
    delete data[SECTEUR_FILTER_KEY]
    delete data[IT_SKILLS_FILTER_KEY]

    // ℹ️ handle topologies filter
    topologies.map((topology) => {
      if (!topology.name) {
        return undefined
      }
      if (data[topology.name]) {
        delete data[topology.name]
      }
      return true // ℹ️ required to prevent eslint error
    })

    onChange(data)
  }

  /* ℹ️ City */
  toggleCityDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (target.tagName !== 'INPUT' && target.tagName !== 'A')) {
      this.setState({
        cityDropdownOpened: !this.state.cityDropdownOpened
      });
    }
  }
  getFilterCity = () => {
    const currentFilterValue = this.getFilter(CITY_FILTER_KEY)
    return currentFilterValue ? currentFilterValue : null
  }
  getFilterRelocation = () => {
    return this.getFilter(RELOCATION_FILTER_KEY)
  }
  getFilterDistance = () => {
    return this.getFilter(DISTANCE_FILTER_KEY)
  }
  deleteCityFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[CITY_FILTER_KEY]
    delete data['latitude']
    delete data['longitude']
    onChange(data)
  }
  deleteRelocationFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[RELOCATION_FILTER_KEY]
    onChange(data)
  }
  deleteDistanceFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[DISTANCE_FILTER_KEY]
    onChange(data)
  }
  renderLocationFilter = () => {
    const {
      isCity,
      onChange,
      searchQuery,
    } = this.props;

    if(!isCity || !isCity.all) {
      return null
    }

    const isActive = this.getFilterCity()

    return (
      <CardCol>
        <Dropdown
          isOpen={this.state.cityDropdownOpened}
          toggle={this.toggleCityDropdown}
          className={`${isActive? 'active': ''}`}>
          <DropdownToggle className={'toggle-btn'}>
            <div className="icon">
              <Tooltip placement="top" overlay="Localisation">
                <Compass size={30}/>
              </Tooltip>
            </div>
          </DropdownToggle>
          <DropdownMenu>
            <div className="input">
              <FilterDistance
                distance={searchQuery?.[DISTANCE_FILTER_KEY]}
                onChange={(data = {}) => onChange(data)} />
              <FilterCity
                city={searchQuery?.city ?? null}
                relocation={searchQuery?.[RELOCATION_FILTER_KEY] === '1'}
                onChange={(data = {}) => onChange(data)}
                onChecked={(data) => this.props.onChange({relocation: data ? 1 : 0})}
                isRemote={isCity.remote}
                placeholder={isCity.placeholder}
              />
            </div>
          </DropdownMenu>
        </Dropdown>
      </CardCol>
    )
  }

  /* ℹ️ Manager */
  toggleManagerDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (target.tagName !== 'SELECT')) {
      this.setState({
        managerDropdownOpened: !this.state.managerDropdownOpened
      });
    }
  };
  getFilterManager = () => {
    const {managers} = this.props
    const currentFilterValue = this.getFilter(MANAGER_FILTER_KEY)
    if(managers.length && currentFilterValue){
      const found = managers.find((manager) => {
        return Number(manager.id) === Number(currentFilterValue)
      })
      if (!found) {
        return null
      }
      return {
        value: found.id,
        label: found.fullname,
      }
    }
  }
  deleteManagerFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[MANAGER_FILTER_KEY]
    onChange(data)
  }
  renderManagerFilter = () => {
    const {
      conf,
      isAdmin,
      isManager,
      onChange,
      searchQuery,
      target,
    } = this.props;

    if((!isAdmin || !isManager) && target !== conf.search.targets.freelances) {
      return null
    }

    const isActive = this.getFilterManager()

    return (
      <CardCol>
        <Fragment>
          <Dropdown
            isOpen={this.state.managerDropdownOpened}
            toggle={this.toggleManagerDropdown}
            className={`${isActive? 'active': ''}`}>
            <DropdownToggle className={'toggle-btn'}>
              <div className="icon">
                <Tooltip placement="bottom" overlay="Responsable">
                  <User size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterManager
                  value={searchQuery?.manager}
                  onChange={(data) => {
                    onChange(data)
                  }}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* ℹ️ Sector */
  toggleSectorDropdown = (event) => {
    const target = (event.target)

    if(target
      && target.tagName
      && !target.classList.contains('Select-placeholder')
      && !target.classList.contains('Select-option')
    ) {
      this.setState({
        sectorDropdownOpened: !this.state.sectorDropdownOpened
      });
    }
  };
  getFilterSector = () => {
    const { secteurs } = this.props
    const sectorFilterId = this.getFilter(SECTEUR_FILTER_KEY)

    if(!sectorFilterId) {
      return
    }

    const sectorFound = secteurs.find((sectorItem) => {
      return sectorItem.value === Number(sectorFilterId)
    })

    if(!sectorFound) {
      return sectorFilterId
    }

    return sectorFound.label
  }
  deleteSectorFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[SECTEUR_FILTER_KEY]
    onChange(data)
  }
  renderSectorFilter = () => {
    const {
      isSecteurs,
      onChange,
      searchQuery,
    } = this.props;
    
    const isActive = this.getFilterSector()

    if(!isSecteurs) {
      return null
    }

    return (
      <CardCol>
        <Fragment>
          <Dropdown
            isOpen={this.state.sectorDropdownOpened}
            toggle={this.toggleSectorDropdown}
            className={`${isActive? 'active': ''}`}>
            <DropdownToggle className={'toggle-btn'}>
              <div className="icon">
                <Tooltip placement="bottom" overlay="Secteurs">
                  <Briefcase size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterSecteur
                  value={searchQuery?.[SECTEUR_FILTER_KEY]}
                  onChange={(data) => onChange(data)}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* ℹ️ MyApplication */
  toggleMyApplicationDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (target.tagName !== 'INPUT')) {
      this.setState({
        myApplicationDropdownOpened: !this.state.myApplicationDropdownOpened
      });
    }
  };
  getFilterMyApplication = () => {
    const currentFilterValue = this.getFilter(MY_APPLICATION_FILTER_KEY)
    return currentFilterValue ? currentFilterValue : null
  }
  deleteMyApplicationFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[MY_APPLICATION_FILTER_KEY]
    onChange(data)
  }
  renderMyApplicationFilter = () => {
    const {
      isOnlyMy,
      onChange,
    } = this.props;

    if(!isOnlyMy) {
      return null
    }

    return (
      <CardCol>
        <Dropdown isOpen={this.state.myApplicationDropdownOpened} toggle={this.toggleMyApplicationDropdown}>
          <DropdownToggle className={'toggle-btn'}>
            <div className="icon">
              <Tooltip placement="bottom" overlay="Candidatures">
                <FileText size={30}/>
              </Tooltip>
            </div>
          </DropdownToggle>
          <DropdownMenu>
            <div className="input">
              <FilterBool
                value={true}
                label="Offres de mission où j'ai postulé "
                onChange={(data) => onChange({
                  onlyMyAnswers: data === true ? 1 : 0
                })}
              />
            </div>
          </DropdownMenu>
        </Dropdown>
      </CardCol>
    )
  }

  /* ℹ️ Types && Topologies*/
  toggleTopologyDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (target.tagName !== 'INPUT')) {
      this.setState({
        topologyDropdownOpened: !this.state.topologyDropdownOpened
      });
    }
  };
  getFilterTypes = () => {
    const {topologies, searchQuery} = this.props
    const types = searchQuery?.type ?? 0
    const currentFilterValues = this.getFilter(TYPE_FILTER_KEY)

    const filtered = []
    if (topologies && currentFilterValues) {
      topologies.forEach((topology) => {
        if(types & topology[0].value) {
          filtered.push(topology[0])
        }
        if(types & topology[1].value) {
          filtered.push(topology[1])
        }
      })

      return filtered // output =>  [{name: string, label: string, value: number}, ...]
    }
  }
  deleteTypesFilter = (filterTypeValue) => {
    const {onChange, searchQuery} = this.props
    onChange({ type: ((searchQuery?.type ?? 0) & ~filterTypeValue) >>> 0 });
  }
  getFreelanceTypologyFilter = () => {
    const {searchQuery, topologies} = this.props

    if(!this.isFreelanceSearch() || !topologies || !topologies.length){
      return
    }

    return topologies.map((topology) => {
      if(!topology.name) {
        return undefined
      }
      const found = searchQuery?.[topology.name] ?? undefined
      if(!found) {
        return undefined
      }
      return {
        name: topology.name,
        value: topology.labels[found === '1' ? 0: 1 ],
      }
    }).filter((topology) => {
      return topology !== undefined
    })
  }
  deleteFreelanceTypologyFilter = (name) => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[name]
    onChange(data)
  }
  renderTopologyFilter = () => {
    const {
      isAdmin,
      onChange,
      topologies,
      searchQuery,
    } = this.props;

    if (!isAdmin) {
      return null
    }

    const hasFilterType = this.getFilterTypes() && this.getFilterTypes().length
    const hasFreelanceTypologyFilter = this.getFreelanceTypologyFilter() && this.getFreelanceTypologyFilter().length
    const isActive =  hasFilterType || hasFreelanceTypologyFilter


    return (<CardCol>
      <div>
        {topologies && topologies.length > 0 &&
            (
              <Fragment>
                <Dropdown isOpen={this.state.topologyDropdownOpened} toggle={this.toggleTopologyDropdown} className={`${isActive ? 'active': ''}`}>
                  <DropdownToggle className={'toggle-btn'}>
                    <div className="icon">
                      <Tooltip placement="bottom" overlay="Topologie">
                        <List size={30}/>
                      </Tooltip>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu>
                    <div className="input">
                      {this.isFreelanceSearch() ?
                        <FreelanceFilterType
                          onChange={(data) => onChange(data)}
                          searchQuery={searchQuery}
                          topologies={topologies}
                        /> :
                        <FilterType
                          onChange={(data) => onChange({type: data})}
                          topologies={topologies}
                          type={searchQuery?.type ?? 0}
                        />
                      }
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </Fragment>
            )}
      </div>
    </CardCol>
    )
  }

  /* NbYearOfExperience */
  toggleNbYearOfExperienceDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (target.tagName !== 'INPUT' && target.tagName !== 'A')) {
      this.setState({
        nbYearOfExperienceDropdownOpened: !this.state.nbYearOfExperienceDropdownOpened
      });
    }
  };
  getFilterNbYearOfExperience = () => {
    const currentFilterValue = this.getFilter(NB_YEAR_OF_EXPERIENCE_FILTER_KEY)
    return currentFilterValue ? currentFilterValue: null
  }
  deleteNbYearOfExperienceFilter = (XpToDelete = undefined) => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery

    if(!XpToDelete) {
      delete data[NB_YEAR_OF_EXPERIENCE_FILTER_KEY]
      onChange(data)
      return
    }

    const removeFilterXpValue = this.getFilterNbYearOfExperience()
      .filter((value) => value !== XpToDelete)

    if(!removeFilterXpValue.length) {
      delete data[NB_YEAR_OF_EXPERIENCE_FILTER_KEY]
      onChange(data)
      return
    }

    data[NB_YEAR_OF_EXPERIENCE_FILTER_KEY] = removeFilterXpValue
    onChange(data)
  }
  renderNbYearOfExperienceFilter = () => {
    const {
      conf,
      isAdmin,
      onChange,
      searchQuery,
    } = this.props;

    if(!isAdmin || !this.isFreelanceSearch()) {
      return null
    }

    const isActive = this.getFilterNbYearOfExperience()

    return (
      <CardCol>
        <Fragment>
          <Dropdown isOpen={this.state.nbYearOfExperienceDropdownOpened} toggle={this.toggleNbYearOfExperienceDropdown} className={`${isActive? 'active': ''}`}>
            <DropdownToggle className={'toggle-btn'}>
              <div className="icon">
                <Tooltip placement="bottom" overlay="Expérience">
                  <Archive size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterExperience
                  conf={conf}
                  experiences={searchQuery?.nbYearOfExperience?.length ? searchQuery.nbYearOfExperience : []}
                  onChange={(data) => onChange({nbYearOfExperience: data})}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* Availability */
  toggleAvailabilityDropdown = (event) => {
    const target = (event.target)
    if(target
      && target.tagName
      && ((target.tagName !== 'BUTTON' || target.classList.contains("toggle-btn"))
      && target.tagName !== 'A')
    ) {
      this.setState({
        availabilityDropdownOpened: !this.state.availabilityDropdownOpened
      });
    }
  };
  getFilterAvailability = () => {
    const currentFilterValue = this.getFilter(AVAILABILITY_FILTER_KEY)
    if(currentFilterValue !== 0 && !currentFilterValue){
      return null
    }
    const found = availabilityChoices.find((choice) => {
      return choice.value === Number(currentFilterValue)
    })
    return found ? found : null
  }

  deleteAvailabilityFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[AVAILABILITY_FILTER_KEY]
    onChange(data)
    return
  }

  renderAvailabilityFilter = () => {
    const {
      isAdmin,
      onChange,
      searchQuery,
    } = this.props;

    if(!isAdmin || !this.isFreelanceSearch()) {
      return null
    }

    const isActive = this.getFilterAvailability()

    return (
      <CardCol>
        <Fragment>
          <Dropdown
            isOpen={this.state.availabilityDropdownOpened}
            toggle={this.toggleAvailabilityDropdown}
            className={`${isActive? 'active': ''} toggle-btn`}>
            <DropdownToggle className={'toggle-btn'}>
              <div className="icon">
                <Tooltip placement="bottom" overlay="Disponibilité">
                  <Calendar size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterAvailability
                  value={parseInt(searchQuery?.availability ?? 0, 10)}
                  onChange={(data) => onChange({availability: data})}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* Languages */
  toggleLanguageDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName !== 'INPUT' && target.tagName !== 'SELECT' ) {
      this.setState({
        languageDropdownOpened: !this.state.languageDropdownOpened
      });
    }
  }
  getFilterLanguage = () => {
    const currentFilterValue = this.getFilter(LANGUAGE_FILTER_KEY)
    return currentFilterValue ? currentFilterValue: null
  }

  extractIdFromLanguageArray = (arr) => {
    if (isArray(arr) && arr.length) {
      const strData = arr[0]
      const split = strData.split(':')
      return split[0]
    }
  }

  deleteLanguageFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[LANGUAGE_FILTER_KEY]
    this.setState({
      languageLabel: undefined,
    })
    onChange(data)
    return
  }
  renderLanguageFilter = () => {
    const {
      isLanguages,
      onChange,
      searchQuery,
    } = this.props;

    if(!this.isFreelanceSearch()) {
      return null
    }

    if(!isLanguages){
      return null
    }

    const isActive = this.getFilterLanguage()

    return (
      <CardCol>
        <Fragment>
          <Dropdown
            isOpen={this.state.languageDropdownOpened}
            toggle={this.toggleLanguageDropdown}
            className={`${isActive? 'active': ''}`}>
            <DropdownToggle className="toggle-btn">
              <div className="icon">
                <Tooltip placement="bottom" overlay="Langues">
                  <MessageSquare size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterLanguages
                  value={searchQuery?.[LANGUAGE_FILTER_KEY]?.length ? searchQuery[LANGUAGE_FILTER_KEY] : []}
                  onChange={(data) => {
                    onChange(data)
                  }}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* ItSkills */
  toggleItSkillsDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName !== 'INPUT'&& (target.tagName !== 'BUTTON' || target.classList.contains('toggle-btn'))) {
      this.setState({
        itSkillsDropdownOpened: !this.state.itSkillsDropdownOpened
      });
    }
  }
  getFilterItSkills = () => {
    const currentFilterValue = this.getFilter(IT_SKILLS_FILTER_KEY)
    return currentFilterValue ? currentFilterValue: null
  }
  deleteItSkillsFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[IT_SKILLS_FILTER_KEY]
    onChange(data)
    return
  }
  renderItSkillsFilter = () => {
    const {
      isItSkills,
      onChange,
      searchQuery,
    } = this.props;

    if(!this.isFreelanceSearch()) {
      return null
    }

    if(!isItSkills){
      return null
    }

    const isActive = this.getFilterItSkills()

    return (
      <CardCol>
        <Fragment>
          <Dropdown
            isOpen={this.state.itSkillsDropdownOpened}
            toggle={this.toggleItSkillsDropdown}
            className={`${isActive? 'active': ''}`}>
            <DropdownToggle className="toggle-btn">
              <div className="icon">
                <Tooltip placement="bottom" overlay="Outils informatiques">
                  <Monitor size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterItSkills
                  value={searchQuery?.[IT_SKILLS_FILTER_KEY]?.length ? searchQuery[IT_SKILLS_FILTER_KEY] : []}
                  onChange={(data) => onChange(data)}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* ℹ️ Prices (TJM) */
  togglePricesDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName !== 'INPUT'&& (target.tagName !== 'BUTTON' || target.classList.contains('toggle-btn'))) {
      this.setState({
        pricesDropdownOpened: !this.state.pricesDropdownOpened
      });
    }
  }
  getFilterPriceMin = () => {
    const currentFilterValue = this.getFilter(PRICE_MIN_FILTER_KEY)
    return currentFilterValue ? currentFilterValue: null
  }
  getFilterPriceMax = () => {
    const currentFilterValue = this.getFilter(PRICE_MAX_FILTER_KEY)
    return currentFilterValue ? currentFilterValue: null
  }
  deletePriceMinFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[PRICE_MIN_FILTER_KEY]
    onChange(data)
    return
  }
  deletePriceMaxFilter = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery
    delete data[PRICE_MAX_FILTER_KEY]
    onChange(data)
    return
  }
  renderPricesFilter = () => {
    const {
      isAdmin,
      isPrices,
      onChange,
      searchQuery,
    } = this.props;

    if(!isAdmin || !this.isFreelanceSearch()) {
      return null
    }

    if(!isPrices){
      return null
    }

    const isActive = this.getFilterPriceMin() || this.getFilterPriceMax()

    return (
      <CardCol>
        <Fragment>
          <Dropdown
            isOpen={this.state.pricesDropdownOpened}
            toggle={this.togglePricesDropdown}
            className={`${isActive? 'active': ''}`}>
            <DropdownToggle className="toggle-btn">
              <div className="icon">
                <Tooltip placement="bottom" overlay="TJM">
                  <DollarSign size={30}/>
                </Tooltip>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className="input">
                <FilterPrices
                  priceMin={searchQuery?.[PRICE_MIN_FILTER_KEY] ?? null}
                  priceMax={searchQuery?.[PRICE_MAX_FILTER_KEY] ?? null}
                  onChange={(data) => onChange(data)}
                />
              </div>
            </DropdownMenu>
          </Dropdown>
        </Fragment>
      </CardCol>
    )
  }

  /* Sorting Order*/
  toggleUserSavedDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (
      target.tagName !== 'INPUT' &&
      target.tagName !== 'SELECT' &&
      target.tagName !== 'OPTION'
    )) {
      this.setState({
        userSavedDropdownOpened: !this.state.userSavedDropdownOpened
      });
    }
  };
  renderUserSavedFilter = () => {
    const {
      isFreelanceSearch,
    } = this.props;

    if(!isFreelanceSearch) {
      return null
    }

    return (
      <CardCol>
        <Dropdown isOpen={this.state.userSavedDropdownOpened} toggle={this.toggleUserSavedDropdown}>
          <DropdownToggle className={'toggle-btn'}>
            <div className="icon">
              <Tooltip placement="bottom" overlay="Filtres sauvegardés">
                <Save size={30}/>
              </Tooltip>
            </div>
          </DropdownToggle>
          <DropdownMenu>
            <UserSavedFilter
              className="filter"
            />
          </DropdownMenu>
        </Dropdown>
      </CardCol>
    )
  }

  /* Sorting Order*/
  toggleOrderDropdown = (event) => {
    const target = (event.target)
    if(target && target.tagName && (target.tagName !== 'DIV')) {
      this.setState({
        orderDropdownOpened: !this.state.orderDropdownOpened
      });
    }
  };
  renderOrderFilter = () => {
    const {
      isAdmin,
      isManager,
      filters,
    } = this.props;

    if(!isAdmin || !isManager) {
      return null
    }

    const ordersFilters = (filters?.orders?.length ? filters.orders : [])
      .filter((item) => {
        const mustBeAdmin = item?.mustBeAdmin;
        const mustBeConnected = item?.mustBeConnected;
        return !((mustBeAdmin && !this.props.isAdmin) || (mustBeConnected && !this.props.currentUser));
      })

    return this.sortingOrdersTemplate(ordersFilters)
  }
  renderFreelanceSearchOrders = () => {
    const {
      filters,
    } = this.props;

    if(!this.isFreelanceSearch()) {
      return null
    }

    const ordersFilters = (filters?.freelanceSearchOrders?.length ? filters.freelanceSearchOrders : [])
      .filter((item) => {
        const mustBeAdmin = item?.mustBeAdmin;
        const mustBeConnected = item?.mustBeConnected;
        return !((mustBeAdmin && !this.props.isAdmin) || (mustBeConnected && !this.props.currentUser));
      })

    if(!ordersFilters.length) {
      return null
    }

    return this.sortingOrdersTemplate(ordersFilters)
  }

  sortingOrdersTemplate = (ordersFilters) => {
    const {
      toggleOrderDropdown,
    } = this;

    const {
      searchQuery,
    } = this.props;

    const {
      orderDropdownOpened,
    } = this.state;

    return (
      <CardCol>
        <Dropdown isOpen={orderDropdownOpened} toggle={toggleOrderDropdown}>
          <DropdownToggle className={'toggle-btn'}>
            <div className="icon">
              <Tooltip placement="bottom" overlay="Tri par date">
                <Calendar size={30}/>
              </Tooltip>
            </div>
          </DropdownToggle>
          <DropdownMenu>
            {ordersFilters.length ?
              <div className="order-filters">
                {ordersFilters.map((item, key) => {
                  return (
                    <FilterOrder
                      searchQuery={searchQuery}
                      key={key}
                      onChange={this.onFiltersChange}
                      name={item.name}
                      label={item.label}
                      tooltip={item.tooltip}
                      className="filter"
                    />
                  )
                })}
              </div> : ''
            }
          </DropdownMenu>
        </Dropdown>
      </CardCol>
    )
  }

  // Modal
  renderFilterModal = () => {
    const  {
      renderLocationFilter,
      renderTopologyFilter,
      renderManagerFilter,
      renderMyApplicationFilter,
      renderAvailabilityFilter,
      renderNbYearOfExperienceFilter,
      renderLanguageFilter,
      renderSectorFilter,
      renderItSkillsFilter,
      renderPricesFilter,
      renderUserSavedFilter,
      renderOrderFilter,
      renderFreelanceSearchOrders,
    } = this

    const deleteFilters = this.renderDeleteFilters(false)

    return (
      <BootstrapModal toggle={this.closeFiltersModal} isOpen={this.state.isFilterModalOpen} className="modal-sm modal-full-height" backdrop="static">
        <ModalBody>
          <CardRow direction="column">
            <CardCol alignSelf={"flex-end"} onClick={this.closeFiltersModal}> <X/> </CardCol>
            <CardCol>
              {deleteFilters}
            </CardCol>
            <CardCol className="pt-3">
              <span className="filter-label">Ajouter un Filtre : </span>
            </CardCol>
            <CardCol>
              <CardRow className={"filters-modal-ctas pt-3"} justify={"space-between"} wrap={"wrap"} gap="1rem 0">
                {renderLocationFilter()}
                {renderTopologyFilter()}
                {renderMyApplicationFilter()}
                {renderNbYearOfExperienceFilter()}
                {renderAvailabilityFilter()}
                {renderLanguageFilter()}
                {renderSectorFilter()}
                {renderItSkillsFilter()}
                {renderPricesFilter()}
                {renderManagerFilter()}
                {renderUserSavedFilter()}

                {renderFreelanceSearchOrders()}
                {renderOrderFilter()}

              </CardRow>
            </CardCol>
            <CardCol className="pt-4" style={{textAlign: "center"}}>
              <button onClick={this.closeFiltersModal} className="btn btn-primary"> Voir résultats </button>
            </CardCol>
          </CardRow>
        </ModalBody>
      </BootstrapModal>
    );
  }
  handleMobileFiltersModalClick = () => {
    this.setState({isFilterModalOpen: true})
  }
  closeFiltersModal = () => {
    this.setState({isFilterModalOpen: false})
  }

  renderDeleteFilters = (showDeleteAllFiltersCta = true) => {
    const {isFreelanceSearch} = this.props

    const {
      deleteCityFilter,
      deleteRelocationFilter,
      deleteDistanceFilter,
      deleteFreelanceTypologyFilter,
      deleteTypesFilter,
      deleteManagerFilter,
      deleteMyApplicationFilter,
      deleteNbYearOfExperienceFilter,
      deleteAvailabilityFilter,
      deleteLanguageFilter,
      deleteSectorFilter,
      deleteItSkillsFilter,
      deletePriceMinFilter,
      deletePriceMaxFilter,
      deleteAllFilters,
      getFilterManager,
      getFilterTypes,
      getFilterCity,
      getFilterRelocation,
      getFilterDistance,
      getFilterMyApplication,
      getFreelanceTypologyFilter,
      getFilterNbYearOfExperience,
      getFilterAvailability,
      getFilterLanguage,
      getFilterSector,
      getFilterItSkills,
      getFilterPriceMin,
      getFilterPriceMax,
    } = this

    const {
      languageLabel
    } = this.state

    const filteredManager = getFilterManager()
    const filteredTypes = getFilterTypes()
    const filteredCity = getFilterCity()
    const filteredRelocation = getFilterRelocation()
    const filteredDistance = getFilterDistance()
    const filteredMyApplication = getFilterMyApplication()
    const filteredFreelanceTypology = getFreelanceTypologyFilter()
    const filteredNbYearOfExperience = getFilterNbYearOfExperience()
    const filteredAvailability = getFilterAvailability()
    const filteredLanguage = getFilterLanguage()
    const filteredSector = getFilterSector()
    const filteredItSkills = getFilterItSkills()
    const filteredPriceMin = getFilterPriceMin()
    const filteredPriceMax = getFilterPriceMax()

    if(
      !filteredManager
      && !filteredTypes
      && !filteredCity
      && !filteredRelocation
      && !filteredDistance
      && !filteredMyApplication
      && (!filteredFreelanceTypology || !filteredFreelanceTypology.length)
      && !filteredNbYearOfExperience
      && !filteredAvailability
      && !filteredSector
      && !filteredItSkills
      && !filteredPriceMin
      && !filteredPriceMax
      && !filteredLanguage
    ) {
      return null
    }

    return (
      <CardRow className="delete-filters" gap="5px" p="10px 0 0 0" justify="space-between" align="center">
        <CardCol flex={1}>
          <CardRow gap="5px" wrap="wrap">
            <CardCol className="delete-filters-label delete-filters-label-desktop">
              Filtre(s) sélectionné(s) :
            </CardCol>

            {filteredCity && (
              (
                <CardCol>
                  <div className="delete-filters-chip" onClick={deleteCityFilter}>
                    {filteredCity} <X size={12}/>
                  </div>
                </CardCol>
              )
            )}

            {!!filteredRelocation && (
              (
                <CardCol>
                  <div className="delete-filters-chip" onClick={deleteRelocationFilter}>
                    Mobile Partout en France<X size={12}/>
                  </div>
                </CardCol>
              )
            )}

            {!!filteredDistance && (
              (
                <CardCol>
                  <div className="delete-filters-chip" onClick={deleteDistanceFilter}>
                    {filteredDistance} km <X size={12}/>
                  </div>
                </CardCol>
              )
            )}

            {!!filteredTypes && !!filteredTypes.length && (
              <Fragment>
                {filteredTypes.map((filteredType, index) => (
                  <CardCol key={`filtered-type-chip-${index}`}>
                    <div className="delete-filters-chip" onClick={() => {
                      deleteTypesFilter(filteredType.value)
                    }}>
                      {filteredType.label} <X size={12}/>
                    </div>
                  </CardCol>
                ))}
              </Fragment>
            )}

            {!!filteredManager &&(
              <CardCol >
                <div className="delete-filters-chip" onClick={deleteManagerFilter}>
                  {filteredManager.label} <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredMyApplication &&(
              <CardCol >
                <div className="delete-filters-chip" onClick={deleteMyApplicationFilter}>
                  Offres de mission où j'ai postulé <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredFreelanceTypology &&(
              <Fragment>
                {filteredFreelanceTypology.map((filteredType, index) => (
                  <CardCol key={`filtered-type-chip-${index}`}>
                    <div className="delete-filters-chip" onClick={() => {
                      deleteFreelanceTypologyFilter(filteredType.name)
                    }}>
                      {filteredType.value} <X size={12}/>
                    </div>
                  </CardCol>
                ))}</Fragment>
            )}

            {!!filteredNbYearOfExperience &&(
              <Fragment>
                {filteredNbYearOfExperience.map((filteredXp, index) => (
                  <CardCol key={index}>
                    <div className="delete-filters-chip" onClick={() => {
                      deleteNbYearOfExperienceFilter(filteredXp)
                    }}>
                      {filteredXp} <X size={12}/>
                    </div>
                  </CardCol>
                ))}
              </Fragment>
            )}

            {!!filteredAvailability &&(
              <CardCol>
                <div className="delete-filters-chip" onClick={() => {
                  deleteAvailabilityFilter()
                }}>
                  {filteredAvailability.text} <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredLanguage && !!languageLabel && (
              <CardCol>
                <div className="delete-filters-chip" onClick={() => {
                  deleteLanguageFilter()
                }}>
                  {languageLabel} <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredSector && (
              <CardCol>
                <div className="delete-filters-chip" onClick={() => {
                  deleteSectorFilter()
                }}>
                  {filteredSector} <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredItSkills &&(
              <CardCol>
                <div className="delete-filters-chip" onClick={() => {
                  deleteItSkillsFilter()
                }}>
                  {filteredItSkills} <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredPriceMin &&(
              <CardCol>
                <div className="delete-filters-chip" onClick={() => {
                  deletePriceMinFilter()
                }}>
                  TJM min : {filteredPriceMin} <X size={12}/>
                </div>
              </CardCol>
            )}

            {!!filteredPriceMax &&(
              <CardCol>
                <div className="delete-filters-chip" onClick={() => {
                  deletePriceMaxFilter()
                }}>
                  TJM max : {filteredPriceMax} <X size={12}/>
                </div>
              </CardCol>
            )}
          </CardRow>
        </CardCol>

        {showDeleteAllFiltersCta && (
          <CardCol>
            <CardRow gap="0.5rem">
              {isFreelanceSearch &&
                <CardCol>
                  <Dropdown
                    isOpen={this.state.savedFilterNameOpened}
                    toggle={() => this.setState({savedFilterNameOpened: !this.state.savedFilterNameOpened})}
                    className={`save-filters`}>
                    <DropdownToggle className={'toggle-btn'}>
                      <div className="icon">
                        <Tooltip placement="top" overlay="Sauvegarder les filtres">
                          <Save size={30}/>
                        </Tooltip>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      <CardRow direction="column" align="center" gap={'0.5rem'} p={'0.5rem'}>
                        <CardCol>
                          <Input type="text" defaultValue={''} onChange={this.onSavedFilterNameChange} />
                        </CardCol>
                        <CardCol>
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={!this.state.savedFilterName || this.state.savedFilterName === ''}
                            onClick={this.onSaveFilter}>
                              Sauvegarder
                          </button>
                        </CardCol>
                      </CardRow>
                    </DropdownMenu>
                  </Dropdown>
                </CardCol>
              }
              <CardCol>
                <button className="btn btn-danger" onClick={deleteAllFilters}>
                  <Trash size={30}/>
                </button>
              </CardCol>
            </CardRow>
          </CardCol>
        )}
      </CardRow>
    )
  }

  onSaveFilter = async () => {
    const {searchQuery} = this.props
    // ℹ️ remove data that shouldn't be saved
    const { limit, page, ...dataToSave} = searchQuery
    const dataToSaveStr = new URLSearchParams(dataToSave).toString()

    await api.freelances.saveSearch({
      name: this.state.savedFilterName,
      filters: dataToSaveStr
    }).then((response) => {
      toastr.success(`Le filtre s'est correctement enregistré` )
      this.setState({savedFilterName: ''})
    }).catch((error) => {
      console.error({error})
      toastr.error('Une erreur est survenue')
    })
  }
  onSavedFilterNameChange = (event) => {
    const {value} = event.currentTarget
    this.setState({savedFilterName: value ? value : ''})
  }

  render() {
    const {
      isConnected,
      isManager,
      isCity,
      topologies,
      className,
    } = this.props;

    const {
      renderDeleteFilters,
      renderFilterModal,
      renderLocationFilter,
      renderManagerFilter,
      renderTopologyFilter,
      renderMyApplicationFilter,
      renderAvailabilityFilter,
      renderNbYearOfExperienceFilter,
      renderLanguageFilter,
      renderSectorFilter,
      renderItSkillsFilter,
      renderPricesFilter,
      renderUserSavedFilter,
      renderOrderFilter,
      renderFreelanceSearchOrders,
    } = this

    if (
      !isConnected || (
        !isCity.all && !isCity.remote && !isManager && !topologies.length
      )
    ) {
      return null;
    }

    return (
      <div className={`filter-bar ${className}`}>
        <div className={'separator'}/>
        {(isConnected) && (
          <Fragment>
            <CardRow className="filters-mobile">
              <CardCol flex={1}>
                <div className='cta' onClick={this.handleMobileFiltersModalClick}> <Menu/> Tous les filtres</div>
              </CardCol>
              <CardCol className="delete-filters-label delete-filters-label-mobile" flex={1}>
                Filtre(s) sélectionné(s) :
              </CardCol>
            </CardRow>
            <CardRow className="filters">
              <CardCol flex="auto">
                <CardRow>
                  {renderLocationFilter()}
                  {renderTopologyFilter()}
                  {renderMyApplicationFilter()}
                  {renderNbYearOfExperienceFilter()}
                  {renderAvailabilityFilter()}
                  {renderLanguageFilter()}
                  {renderSectorFilter()}
                  {renderItSkillsFilter()}
                  {renderPricesFilter()}
                  {renderManagerFilter()}
                  {renderUserSavedFilter()}
                </CardRow>
              </CardCol>
              <CardCol>
                <CardRow>
                  {renderFreelanceSearchOrders()}
                  {renderOrderFilter()}
                </CardRow>
              </CardCol>
            </CardRow>

            {renderDeleteFilters()}

            <div className={'filters-modal'}>
              {renderFilterModal()}
            </div>
          </Fragment>
        )}
      </div>
    )}
}

export default connect(
  (state) => ({
    secteurs: state.secteurs.secteurs.map(secteur => ({
      value: secteur.id,
      label: secteur.name
    }))
  })
)(withManagers(FilterBar))
